import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from './consts';

export const stripeLoadingPromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
